module.exports = __webpack_public_path__ + "img/Carestream.a3510abe.png";